import { EnvironmentEnum } from '../enums';
import { ConfigInterface } from '../types';

export const config: ConfigInterface = {
  environmentName: EnvironmentEnum.dvp,
  backends: [
    {
      id: 'contract',
      baseUrl: 'https://api-test.gems.engie.com/wattson-api/dvp/contracts',
      config: {
        token: '79191959f1834c32bb80402a9ad22eda',
      },
    },
    {
      id: 'customer',
      baseUrl: 'https://api-test.gems.engie.com/wattson-api/dvp/customers',
    },
    {
      id: 'portal',
      baseUrl: 'https://api-test.gems.engie.com/wattson-api/dvp/portal',
    },
    {
      id: 'user',
      baseUrl: 'https://api-test.gems.engie.com/wattson-api/dvp/users',
    },
    {
      id: 'volume',
      baseUrl: 'https://api-test.gems.engie.com/wattson-api/dvp/volumes',
    },
    {
      id: 'core',
      baseUrl: 'https://api-test.gems.engie.com/wattson-api/dvp/core',
    },
    {
      id: 'riskModeler',
      baseUrl: 'https://api-test.gems.engie.com/dev/customers/wattson-woot/contract-risk-modeler',
    },
    {
      id: 'midBack',
      baseUrl: 'https://api-test.gems.engie.com/wattson-midback/dev',
    },
    {
      id: 'supplyData',
      baseUrl: 'https://api-test.gems.engie.com/wattson-supplydata/dev',
    },
  ],
};
